import React, { useEffect } from 'react';

import Wait from './Wait';
import CreatePolicy from './CreatePolicy';
import GeneralForm from '../GeneralForm/Index';
import Plans from '../Plans/Index';
import Documents from '../Documents/Index';
import PaymentMethods from '../PaymentMethods/Index';
import Invoices from '../Invoices/Index';

import { useContext } from '../Context';
import Loader from '../../../ui/Loader';

export default function Main({ enterpriseId }) {
  const { dispatch, actions, state } = useContext();

  useEffect(() => {
    actions.load(dispatch, state.enterpriseId);
  }, []);

  return (
    <>
      {state.viewMode == 'load' && <Wait />}
      {state.viewMode == 'view' && state.policy.id == '' && <CreatePolicy />}
      {state.policy && state.policy.id != '' && (
        <>{state.viewMode == 'view' && <GeneralForm />}</>
      )}
      {state.policy && state.policy.id != '' && (
        <>
          <Plans />
          <Documents />
          <PaymentMethods enterpriseId={state.enterpriseId} />
          <Invoices />
        </>
      )}
    </>
  );
}
